
enum PricingStrategyRuleEvaluate {
	LEAST_EXPENSIVE = 'LEAST_EXPENSIVE', MOST_EXPENSIVE = 'MOST_EXPENSIVE', MEDIAN = 'MEDIAN'
}

export default PricingStrategyRuleEvaluate